<div class="radio--container">
  <legend [class.bold-label]="boldLabel()" [class.default-label]="!boldLabel()">{{ field().label }}</legend>
  @if (field().required) {
    <span class="required" aria-required="true"></span>
  }
  <div class="radio-options-container">
    @for (option of field().options; track option.key; let i = $index) {
      <label
        [for]="field().key + '_' + option.key"
        class="body1"
        [formGroup]="parentForm()"
        [class.last]="i === field().options.length - 1"
        [class.disabled]="parentForm().controls[field().key].disabled"
      >
        <input
          type="radio"
          [id]="field().key + '_' + option.key"
          [attr.name]="field().key"
          [formControlName]="field().key"
          [value]="option.key"
          [attr.checked]="option.key?.toString() === currentValue()?.toString() ? '' : null"
          class="body1"
          (change)="updateValue($event)"
        />
        {{ option.value }}
      </label>
    }
  </div>
</div>
